import React from "react";
import { AppLayout } from "../shared/layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  FileText,
  Settings,
  Mail,
  Search,
  DollarSign,
  TrendingUp,
  Flag,
} from "lucide-react";

const quickLinks = [
  {
    title: "Tüm Faturalar",
    description: "Tüm faturaları görüntüle ve yönet",
    path: "/invoices-all",
    icon: FileText,
    gradient: "from-emerald-500 to-teal-600",
    hoverGradient: "hover:from-emerald-600 hover:to-teal-700",
  },
  {
    title: "Fatura Operasyonları",
    description: "Fatura operasyonlarını yönet",
    path: "/invoices-operations",
    icon: Settings,
    gradient: "from-blue-500 to-indigo-600",
    hoverGradient: "hover:from-blue-600 hover:to-indigo-700",
  },
  {
    title: "Mail Gönderilen Komisyonlar",
    description: "Komisyon maillerini takip et",
    path: "/invoices-operations-commission",
    icon: DollarSign,
    gradient: "from-amber-500 to-orange-600",
    hoverGradient: "hover:from-amber-600 hover:to-orange-700",
  },
  {
    title: "Mail Gönderim İşlemleri",
    description: "Mail işlemlerini yönet",
    path: "/mail-send-operations",
    icon: Mail,
    gradient: "from-purple-500 to-pink-600",
    hoverGradient: "hover:from-purple-600 hover:to-pink-700",
  },
  {
    title: "Influencer Ara",
    description: "Influencer ara ve bul",
    path: "/influencer-search",
    icon: Search,
    gradient: "from-cyan-500 to-blue-600",
    hoverGradient: "hover:from-cyan-600 hover:to-blue-700",
  },
  {
    title: "Azerbaycan < $10",
    description: "10 doların altındaki Azerbaycan komisyonları",
    path: "/azerbaijan-low-amount",
    icon: Flag,
    gradient: "from-rose-500 to-red-600",
    hoverGradient: "hover:from-rose-600 hover:to-red-700",
  },
];

export function HomeScreen() {
  return (
    <AppLayout title="Hızlı Erişim">
      <div className="px-4 py-8">
        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-foreground mb-2">
            Hızlı Erişim
          </h1>
          <p className="text-muted-foreground">
            En sık kullandığınız özelliklere hızlıca erişin
          </p>
        </div>

        {/* Quick Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quickLinks.map((link) => {
            const Icon = link.icon;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="group block transition-transform hover:scale-105"
              >
                <Card className="h-full border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-xl overflow-hidden">
                  <CardContent className="p-0">
                    {/* Gradient Header */}
                    <div
                      className={`bg-gradient-to-br ${link.gradient} ${link.hoverGradient} p-6 transition-all duration-300`}
                    >
                      <div className="flex items-center justify-between">
                        <Icon className="h-10 w-10 text-white drop-shadow-lg" />
                        <div className="h-12 w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white/30 transition-colors">
                          <TrendingUp className="h-6 w-6 text-white" />
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {link.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {link.description}
                      </p>
                    </div>

                    {/* Footer */}
                    <div className="px-6 pb-6">
                      <Button
                        variant="ghost"
                        className="w-full group-hover:bg-primary/10 group-hover:text-primary transition-colors"
                      >
                        Open →
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
}
